<template>
	<AppDropdown
		:popover-props="{
			distance: 0,
			placement: 'bottom',
		}"
		:trigger-button-props="{
			'v-tooltip': triggerButtonLabel,
			'aria-label': triggerButtonLabel,
			class: 'task-list-row-add-task-quick-actions__trigger',
		}"
	>
		<template #trigger>
			<SuiIcon name="icon-meatballs-16" />
		</template>

		<SuiListGroup v-close-popper :list-data="quickActionsList" />
	</AppDropdown>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useTranslation } from '@/composables';
import { type SuiListGroupData } from '@/types';
import { SuiIcon, SuiListGroup } from '@developers/scoro-ui';
import AppDropdown from '@/features/App/AppDropdown/AppDropdown.vue';
import { useTaskListStore } from '../store';
import { UNGROUPED_TASKS_ID } from '../constants';
import { type ProjectPhase, type Task } from '@/generated/graphql';
import { TaskBundlePlacement } from '../types';

export type TaskListRowAddTaskQuickActionsProps = {
	projectPhaseId?: ProjectPhase['id'];
	taskId?: Task['id'];
};

const props = defineProps<TaskListRowAddTaskQuickActionsProps>();

const { t } = useTranslation();
const taskListStore = useTaskListStore();

const triggerButtonLabel = t('spa__quickActions.name');

const quickActionsList = computed<SuiListGroupData[]>(() => {
	return [
		{
			id: 'task-list-row-add-task-quick-actions',
			items: [
				{
					id: 'add-task-set',
					title: props.taskId
						? t('add_task_set_as_subtasks')
						: t('add_task_set'),
					icon: {
						name: 'icon-taskbundle-16',
					},
					click: () => {
						if (props.taskId) {
							taskListStore.subtaskBundleOpen = props.taskId;
							return;
						}

						taskListStore.$patch({
							taskBundlePlacement: TaskBundlePlacement.Bottom,
							taskBundleOpen:
								props.projectPhaseId || UNGROUPED_TASKS_ID,
						});
					},
				},
			],
		},
	];
});
</script>

<style lang="scss">
.task-list-row-add-task-quick-actions {
	&__trigger {
		min-height: 4rem;
		border-radius: 0.5rem;
		padding: 1rem;

		&:hover {
			background-color: $neutral-20;
		}
	}
}
</style>
